module.exports = __webpack_public_path__ + "media/images/avatar-5fedd64859d19a7179b8c292cc64fc39.png";